module.exports = __webpack_public_path__ + "spotify_podcasts-e359ad39480a3ed8d413.svg";